export default {
  namespaced: true,
  state: () => ({
    excludedConversationIds: [],
  }),

  mutations: {
    toggleExcludedConversationId(state, {conversationId}) {
      state.excludedConversationIds = _.xor(state.excludedConversationIds, [conversationId]);
    },

    clearExcludedConversationIds(state) {
      state.excludedConversationIds = [];
    },
  },
};
